import { Stack } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import pubsub from '../../../../../modules/pubsub'
import { IFrozenInventoryItem } from '../../../../../shared/types'
import Spreadsheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import AddNewProductForm from './forms/AddNewProduct.form'
import ExportProducts from './forms/ExportProducts.form'
import PageHeader from './PageHeader'
import PageContent from './page_content'


export default function Main() {

   
    const [isExportModalOpen, setIsExportModalOpen] = useState(false)
    const [isAddModalOpen, setIsAddModalOpen] = useState(false)
    

    const handleOnHeaderBtnSecondaryClick =()=>{
        setIsExportModalOpen(isExportModalOpen ? false : true)
    }
    const handleOnHeaderBtnPrimaryClick =()=>{
        setIsAddModalOpen(isAddModalOpen ? false : true)
    }

    const handleOnExport = (data:IFrozenInventoryItem[])=>{

        if(data.length <= 0){
            toast("Error: No shops were created within the range you selected",{
                position: "top-center",
                type: "error",
                hideProgressBar: true,
                theme: "dark"
            })
            return
        }

        const rows = ["Name", "Brand","Carton Type", "Kilos Per Carton","Cost Price Per Carton", "Cost Price Per Kilo","Selling Price Carton", "Selling Price Per Kilo", "Created At"]
        const cols:(string|number)[][] = [];

        data.forEach((product)=>{
            const arr = [product.name, 
                        product.brand ?? "",
                        product.carton_type ?? "", 
                        product.kilos_per_carton, 
                        product.cost_price_per_carton, 
                        product.selling_price_per_carton, 
                        product.selling_price_per_kilo, 
                        new Date(product.created_at as Date).toDateString()
            ]
            cols.push(arr)
        })


        const aoa = [
            rows,
            ...cols
        ]

        Spreadsheet.aoaToSpreadSheet(aoa, "Product listings")
        setIsExportModalOpen(false)
        
        
    }

    const handleOnNewProductAdded = ()=>{

        pubsub.trigger("inventory:changed")
        setIsAddModalOpen(false)
        toast("New product added successfully.", {
            type: "success",
            theme: "dark",
            position: "top-center",
            hideProgressBar: true,
            autoClose: 5000
        })
        
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <PageHeader onBtnPrimaryClick={handleOnHeaderBtnPrimaryClick} onBtnSecondaryClick={handleOnHeaderBtnSecondaryClick} />
            <PageContent />

            {/* Export modal */}
            <Modal
                title="Export inventory history"
                subtitle="Select time range to export data"
                visible={isExportModalOpen}
                setVisibility={setIsExportModalOpen}
            >
                <ExportProducts 
                    onDone={handleOnExport}
                    onFail={()=>{}}
                />
            </Modal>

            {/* Add Modal */}
            <Modal
                title="Add to inventory"
                subtitle="Please complete the form to add new item to inventory"
                visible={isAddModalOpen}
                setVisibility={setIsAddModalOpen}
            >
                <AddNewProductForm 
                    onDone={handleOnNewProductAdded}
                    onFail={()=>{}}
                />
            </Modal>

        </Stack>
    )

}


